import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _b5336826 = () => interopDefault(import('../pages/countries.vue' /* webpackChunkName: "pages/countries" */))
const _0b763fd0 = () => interopDefault(import('../pages/help.vue' /* webpackChunkName: "pages/help" */))
const _673a03a2 = () => interopDefault(import('../pages/no-subscription.vue' /* webpackChunkName: "pages/no-subscription" */))
const _21a5cbb3 = () => interopDefault(import('../pages/redirect.vue' /* webpackChunkName: "pages/redirect" */))
const _7d7ed1c0 = () => interopDefault(import('../pages/terms.vue' /* webpackChunkName: "pages/terms" */))
const _58fdd8ea = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _3549753b = () => interopDefault(import('../pages/_countryCode.vue' /* webpackChunkName: "pages/_countryCode" */))
const _4f0c3904 = () => interopDefault(import('../pages/_countryCode/index.vue' /* webpackChunkName: "pages/_countryCode/index" */))
const _0835f048 = () => interopDefault(import('../pages/_countryCode/_disciplineCode.vue' /* webpackChunkName: "pages/_countryCode/_disciplineCode" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'hash',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/countries",
    component: _b5336826,
    name: "countries"
  }, {
    path: "/help",
    component: _0b763fd0,
    name: "help"
  }, {
    path: "/no-subscription",
    component: _673a03a2,
    name: "no-subscription"
  }, {
    path: "/redirect",
    component: _21a5cbb3,
    name: "redirect"
  }, {
    path: "/terms",
    component: _7d7ed1c0,
    name: "terms"
  }, {
    path: "/",
    component: _58fdd8ea,
    name: "index"
  }, {
    path: "/:countryCode",
    component: _3549753b,
    children: [{
      path: "",
      component: _4f0c3904,
      name: "countryCode"
    }, {
      path: ":disciplineCode",
      component: _0835f048,
      name: "countryCode-disciplineCode"
    }]
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
